<template>
  <div class="page">
    <div class="page-container">
      <template v-if="!applied">
        <project-page-header ref="pageHeader" :id="projectId">
          <template v-slot:actions>
            <a-space>
              <a-button class="v-px-sm" icon="left" size="default" type="default" @click="$router.push(`../view/basic?id=${projectId}`)">返回项目详情</a-button>
            </a-space>
          </template>
        </project-page-header>
        <div class="page-title">填报财务请款单</div>
        <div class="panel-body">
          <div class="panel-info-section">
            <div v-if="record.checkResult === -1">
              <a-alert class="v-mb-sm no-border" type="error">
                <div slot="message">
                  <div class="font-md text-darkblue flex items-center"><a-icon type="alert" class="v-mr-xs" />此财务请款单已被驳回</div>
                  <div class="flex v-mt-xs">
                    <span class="text-right text-grey">审核意见：</span>
                    <span class="col text-red" v-html="$utils.convertToHtml(record.checkOpinion)"></span>
                  </div>
                </div>
              </a-alert>
            </div>
            <div class="panel-info-section-title">
              <a-icon type="caret-right" class="text-primary" />
              <span class="text-bold">基本信息</span>
            </div>
            <div class="w1200">
              <a-form-model class="form-sm" ref="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }" :model="form">
                <a-row>
                  <a-col span="12">
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        请款金额
                      </span>
                      <a-input type="number" placeholder="请款金额" v-model="form.applyAmount" ref="applyAmount" suffix="元" disabled style="width: 300px" />
                    </a-form-model-item>
                  </a-col>
                  <a-col span="12">
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        申请日期
                      </span>
                      <a-date-picker format="YYYY-MM-DD" value-format="YYYY-MM-DD" placeholder="选择日期" ref="applyDate" v-model="form.applyDate" style="width: calc(100% - 10px)" />
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col span="12">
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        收款单位抬头
                      </span>
                      <!-- <a-input v-model="form.billTitle" ref="billTitle" placeholder="单位抬头" style="width: 300px" /> -->
                      <a-auto-complete ref="billTitle" v-model="form.billTitle" style="width: 300px" placeholder="收款单位" allow-clear :filter-option="filterOption" @change="onTitleChange" option-label-prop="label" :dropdown-match-select-width="true">
                        <template slot="dataSource">
                          <a-select-option v-for="item in banks.filter(d => d.title)" :key="`${item.title}♦${item.name}♦${item.card}`" :label="item.title">
                            <div class="ellipsis">
                              <div class="text-brown text-bold">{{ item.title }}</div>
                              <div class="font-xs text-grey">{{ item.name }}，{{ item.card }}</div>
                            </div>
                          </a-select-option>
                        </template>
                      </a-auto-complete>
                    </a-form-model-item>
                  </a-col>
                  <a-col span="12">
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        开户行
                      </span>
                      <a-input placeholder="格式为：*** 银行 *** 市分行 *** 支行" v-model="form.bankName" ref="bankName" style="width: calc(100% - 10px)" />
                    </a-form-model-item>
                  </a-col>
                  <a-col span="12">
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        银行账号
                      </span>
                      <a-input v-model="form.bankCard" ref="bankCard" placeholder="银行账号" style="width: 300px" />
                    </a-form-model-item>
                  </a-col>
                  <a-col span="24">
                    <a-form-model-item :colon="false" :label-col="{ span: 3 }" :wrapper-col="{ span: 18 }">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        请款事项说明
                      </span>
                      <a-textarea :auto-size="{ minRows: 4 }" v-model="form.applyRemark" ref="applyRemark" placeholder="请款说明" style="width: calc(100% - 10px)" />
                      <!-- <div class="ant-form-explain text-grey text-justify">项目的执行效果，35个汉字以内，该内容会展示在捐款前提示中</div> -->
                    </a-form-model-item>
                  </a-col>
                </a-row>
              </a-form-model>
            </div>
          </div>
          <div class="panel-info-section">
            <div class="flex items-center">
              <div class="panel-info-section-title">
                <a-icon type="caret-right" class="text-primary" />
                <span class="text-bold">项目预算请款明细</span>
              </div>
              <a-button icon="control" type="indigo" size="small" class="v-ml-auto" @click="rmbModal = true">查看费用报销比率</a-button>
            </div>
            <div class="flex">
              <div class="col">
                <a-table :data-source="budgetsTableData" key="table-edit" class="list-table" size="small" rowKey="uid" :loading="loading" :expanded-row-keys.sync="expandedBudgetKeys" :pagination="false" :scroll="{ x: '100%' }" :expand-icon-column-index="1">
                  <a-table-column title="序号" data-index="index" :width="60" align="left">
                    <template slot-scope="text, record">
                      {{ record.no }}
                    </template>
                  </a-table-column>
                  <a-table-column title="费用名称" data-index="name" :ellipsis="true" :width="280" align="left">
                    <template slot-scope="text, record">
                      <span :class="{ 'text-bold': record.sum }">{{ record.name || '-' }}</span>
                    </template>
                  </a-table-column>
                  <a-table-column title="费用类别" data-index="cate" :width="300" align="left">
                    <template slot-scope="text, record" v-if="!record.isRoot">
                      <div class="flex items-center">
                        <span class="col ellipsis" :title="record.cateFullName">{{ record.cateFullName }}</span>
                        <a-tag class="ml-auto v-pl-xs tag-tiny v-mr-none text-indigo" v-if="record.costRate != void 0">{{ record.costRate }}%</a-tag>
                      </div>
                    </template>
                  </a-table-column>
                  <a-table-column title="费用年份" data-index="year" :width="90" align="center" :ellipsis="true">
                    <template slot-scope="text, record">
                      <template v-if="!record.isRoot">{{ record.year || '-' }}</template>
                    </template>
                  </a-table-column>
                  <a-table-column title="单价" data-index="price" :width="120" align="right" :ellipsis="true">
                    <template slot-scope="text, record">
                      <template v-if="!record.isRoot">{{ record.price || '-' }}</template>
                    </template>
                  </a-table-column>
                  <a-table-column title="数量" data-index="quantity" :width="90" align="right">
                    <template slot-scope="text, record">
                      <template v-if="!record.isRoot">{{ record.quantity || '-' }}</template>
                    </template>
                  </a-table-column>
                  <a-table-column title="预算金额" data-index="amount" :width="120" align="right">
                    <template slot-scope="text, record">
                      <span :class="{ 'text-bold': record.sum }">{{ $utils.thousands(record.amount) }}</span>
                    </template>
                  </a-table-column>
                  <a-table-column title="已请款金额" data-index="applied" :width="115" align="right">
                    <template slot-scope="text, record">
                      <span :class="{ 'text-bold': record.sum }" v-if="!record.remains">{{ record.extra ? '' : $utils.thousands(record.applied) }}</span>
                    </template>
                  </a-table-column>
                  <a-table-column title="本次请款金额" :custom-cell="record => ({ class: 'td-bright' })" :width="123" align="right">
                    <template slot-scope="text, record">
                      <div class="relative-position" v-if="!record.isRoot">
                        <!-- <a-input class="text-right text-red" type="number" size="small" style="width: 100%" v-model="record.applyAmount" :ref="`applyAmount-${record.uid}`" /> -->
                        <a-input-number
                          :placeholder="record.applied >= record.amount ? '无请款额度' : ''"
                          :disabled="!applyId && (!record.cateId || ([2, 3].includes(record.cateRoot) && (record.costRate == void 0 || record.costRate === 0)) || record.applied >= record.amount)"
                          class="no-handler text-right text-red"
                          size="small"
                          v-model="record.applyAmount"
                          :ref="`applyAmount-${record.uid}`"
                          @keyup="refreshAmount"
                          :formatter="value => $utils.numInputFormatter(value)"
                          :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                          :min="0"
                          style="width: 100%"
                        />
                        <a-tooltip placement="top" :title="isOverApply(record)" v-if="isOverApply(record) != ''">
                          <span class="icon-invalid cursor-pointer"><i class="fa fa-exclamation-circle" aria-hidden="true"></i></span>
                        </a-tooltip>
                      </div>
                      <span :class="{ 'text-bold': record.sum, 'text-red': record.applyAmount > 0 }" v-else-if="!record.remains">{{ record.extra ? '' : $utils.thousands(record.applyAmount) }}</span>
                    </template>
                  </a-table-column>
                  <a-table-column title="请款金额累计" data-index="accuApply" :width="120" align="right">
                    <template slot-scope="text, record">
                      <span :class="{ 'text-bold': record.sum }" v-if="!record.remains">{{ record.extra ? '' : $utils.thousands(record.applied + (record.applyAmount || 0)) }}</span>
                    </template>
                  </a-table-column>
                  <a-table-column title="实际支出金额" data-index="expensed" :width="120" align="right">
                    <template slot-scope="text, record">
                      <span :class="{ 'text-bold': record.sum }" v-if="!record.remains">{{ record.extra ? '' : $utils.thousands(record.expensed) }}</span>
                    </template>
                  </a-table-column>
                  <a-table-column title="请款余额" :custom-cell="record => ({ class: 'td-bright' })" data-index="accuRemainApplied" :width="119" align="right">
                    <template slot-scope="text, record">
                      <span :class="{ 'text-bold': record.sum, 'text-red': record.applied + (record.applyAmount || 0) - record.expensed > 0 }" v-if="!record.remains">{{ record.extra ? '' : $utils.thousands(record.applied + (record.applyAmount || 0) - record.expensed) }}</span>
                    </template>
                  </a-table-column>
                  <a-table-column title="差额" data-index="subtract" :width="110" align="right">
                    <template slot-scope="text, record">
                      <span :class="{ 'text-bold': record.sum }" v-if="!record.remains">{{ record.extra ? '' : $utils.thousands(record.amount - record.expensed) }}</span>
                    </template>
                  </a-table-column>
                  <a-table-column title="预算备注" data-index="remark" :ellipsis="true" :width="300" align="left">
                    <template slot-scope="text, record">
                      {{ record.remark }}
                    </template>
                  </a-table-column>
                </a-table>
              </div>
            </div>
            <div class="flex items-center v-mt-xs" v-if="budgetsTableData.length > 0">
              <span class="col font-xs">
                提示：
                <i class="text-red fa fa-exclamation-circle" aria-hidden="true"></i>
                表示项不符合要求，提交至审核时有
                <i class="text-red fa fa-exclamation-circle" aria-hidden="true"></i>
                标志将无法提交。
              </span>
            </div>
            <div class="text-center v-my-lg">
              <a-space>
                <a-button icon="check" type="indigo" key="draft" @click="handleConfirm(false)" :loading="saving">保存初稿</a-button>
                <a-button icon="arrow-right" type="primary" key="submit" @click="handleConfirm(true)" :loading="saving">提交审核</a-button>
                <a-button icon="left" type="default" key="backward" @click="$router.go(-1)">返回</a-button>
              </a-space>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <a-result status="success" title="提交成功" sub-title="您提交的请款单已提交审核，请耐心等待审核结果。">
          <template #extra>
            <a-button key="view" type="primary" @click="$router.push(`../view?id=${projectId}`)">查看项目</a-button>
            <a-button key="back" @click="$router.go(-1)">返回</a-button>
          </template>
        </a-result>
      </template>
    </div>
    <a-modal :mask-closable="false" centered title="费用报销比例" :footer="null" :visible="rmbModal" @cancel="rmbModal = false" :width="960" :body-style="{ padding: '12px' }">
      <a-table class="list-table" size="small" rowKey="uid" :pagination="false" :data-source="rmbRecords" :scroll="{ x: '100%' }" :expand-icon-column-index="1">
        <a-table-column title="序号" data-index="index" :width="60" align="left">
          <template slot-scope="text, record, index" v-if="record.isRoot && !record.sum">
            {{ index + 1 }}
          </template>
        </a-table-column>
        <a-table-column title="费用类别" data-index="name" :width="300" align="left">
          <template slot-scope="text, record">
            <span class="col ellipsis" v-if="record.isRoot && !record.sum">{{ record.cateFullName }}</span>
            <span :class="{ 'text-bold': record.sum }" v-else>{{ record.name || '-' }}</span>
          </template>
        </a-table-column>
        <a-table-column title="预算金额" data-index="amount" :width="110" align="right">
          <template slot-scope="text, record">
            <span :class="{ 'text-bold': record.sum }">{{ $utils.thousands(record.amount) }}</span>
          </template>
        </a-table-column>
        <a-table-column title="费用报销比例" data-index="costRate" :width="120" align="right">
          <template slot-scope="text, record" v-if="record.isRoot && !record.sum">
            <a-tag class="tag-tiny text-indigo" v-if="record.costRate != void 0">{{ record.costRate }}%</a-tag>
          </template>
        </a-table-column>
        <a-table-column title="费用报销上限" data-index="cateAmount" :width="110" align="right">
          <template slot-scope="text, record" v-if="record.isRoot && !record.sum">
            <span>{{ $utils.thousands(record.cateAmount) }}</span>
          </template>
        </a-table-column>
        <a-table-column title="请款金额" data-index="applied" :width="110" align="right">
          <template slot-scope="text, record">
            <span :class="{ 'text-bold': record.sum }">{{ record.extra ? '' : $utils.thousands(record.applied) }}</span>
          </template>
        </a-table-column>
        <a-table-column title="实际支出金额" data-index="expensed" :width="110" align="right">
          <template slot-scope="text, record">
            <span :class="{ 'text-bold': record.sum }">{{ record.extra ? '' : $utils.thousands(record.expensed) }}</span>
          </template>
        </a-table-column>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import ProjectPageHeader from '../common/page-header'
import { saveApplyBill, getApplyBill, getBudgetsWithAmount, listApplyBillBanks } from '@/api/project/common'
import { convertBudgetsRecords } from '@/utils/data'
export default {
  name: 'FundedProjectApplyBill',
  components: {
    ProjectPageHeader,
  },
  data() {
    return {
      projectId: +this.$route.query.id,
      applyId: this.$route.query.aid,
      loading: false,
      tasks: [],
      expandedTableKeys: [],
      saving: false,
      applied: false,
      record: {},
      budgets: [],
      budgetsTableData: [],
      expandedBudgetKeys: [],
      currentRecord: {},
      form: {
        applyId: undefined,
        applyAmount: 0,
        applyDate: undefined,
        billTitle: '',
        bankName: '',
        bankCard: '',
        applyRemark: '',
      },
      availableAmount: 0,
      overLimited: false,
      banks: [],
      rmbRecords: [],
      rmbModal: false,
    }
  },
  watch: {
    $route() {
      this.init()
    },
  },
  methods: {
    init() {
      let { id, aid } = this.$route.query
      if (id) {
        this.projectId = +id
      }
      if (aid) {
        // 草稿，预算从详情中取
        this.applyId = +aid
        this.loadApplyBill()
      } else {
        this.loadBudgets()
      }
      this.listBanks()
    },
    loadApplyBill() {
      getApplyBill(this.applyId).then(({ data }) => {
        if (data.success) {
          let {
            applyId,
            applyAmount,
            applyDate,
            billTitle,
            bankName,
            bankCard,
            applyRemark,
            budgets,
            project: { raisedAmount = 0, ownManageRate = 0 },
          } = data.result
          this.record = data.result
          this.availableAmount = this.$utils.subtract(raisedAmount, (raisedAmount * ownManageRate) / 100)
          Object.assign(this.form, { applyId, applyAmount, applyDate, billTitle, bankName, bankCard, applyRemark })
          this.budgets = budgets
          let { tableRecords, rmbRecords } = convertBudgetsRecords(budgets, { showOwnManage: true, raisedAmount, ownManageRate })
          this.budgetsTableData = tableRecords
          this.rmbRecords = rmbRecords
          this.expandedBudgetKeys = tableRecords.filter(d => d.children && d.children.length).map(d => d.uid)
        }
      })
    },
    loadBudgets() {
      this.loading = true
      getBudgetsWithAmount(this.projectId).then(({ data }) => {
        this.loading = false
        if (data.success) {
          let { records, raisedAmount = 0, ownManageRate = 0 } = data.result
          this.budgets = records
          this.availableAmount = this.$utils.subtract(raisedAmount, (raisedAmount * ownManageRate) / 100)
          let { tableRecords, rmbRecords } = convertBudgetsRecords(records, { showOwnManage: true, raisedAmount, ownManageRate })
          this.budgetsTableData = tableRecords
          this.rmbRecords = rmbRecords
          this.expandedBudgetKeys = tableRecords.filter(d => d.children && d.children.length).map(d => d.uid)
        }
      })
    },
    isOverApply(record) {
      // const { overLimited } = this
      const { cateId, cateRoot, costRate, applyAmount, applied, amount, cateAmount, manageAmount, ownManageAmount } = record
      if (applyAmount == void 0) {
        return ''
      }
      if (this.overLimited) {
        return '请款金额超出剩余预算额度'
      }
      const { add } = this.$utils
      if (applyAmount > 0 && add(applied, applyAmount) > amount) {
        return '请款金额超出剩余预算额度'
      }
      if (cateId && costRate) {
        // 不能超过科目报销金额
        // 查找费用分类对应的所有预算
        const budgets = this.budgetsTableData
          .filter(d => !d.sum)
          .filter(d => d.children && d.children.some(s => s.cateId == cateId))
          .map(d => d.children.filter(s => s.cateId == cateId))
          .flat()
        let cateApplyAmount = 0
        let cateAppliedAmount = 0
        budgets.forEach(d => {
          cateApplyAmount = add(cateApplyAmount, d.applyAmount)
          cateAppliedAmount = add(cateAppliedAmount, d.applied)
        })
        console.log('当前分类本次请款金额', cateApplyAmount)
        console.log('当前分类已报销金额', cateAppliedAmount)
        console.log('当前分类报销金额上限', cateAmount)
        if (add(cateApplyAmount, cateAppliedAmount) > cateAmount) {
          return '超出费用分类报销金额上限'
        }
      }
      if (cateRoot == 2 || cateRoot == 3) {
        const budgets = this.budgetsTableData
          .filter(d => !d.sum)
          .filter(d => d.children && d.children.some(s => s.cateRoot == cateRoot))
          .map(d => d.children.filter(s => s.cateRoot == cateRoot))
          .flat()
        let cateApplyAmount = 0
        let cateAppliedAmount = 0
        budgets.forEach(d => {
          cateApplyAmount = add(cateApplyAmount, d.applyAmount)
          cateAppliedAmount = add(cateAppliedAmount, d.applied)
        })
        const totalAmount = cateRoot == 2 ? manageAmount : ownManageAmount 
        console.log(manageAmount)
        console.log('当前管理费本次报销金额', cateApplyAmount)
        console.log('当前管理费已报销金额', cateAppliedAmount)
        console.log('当前管理费报销金额上限', totalAmount)
        if (add(cateApplyAmount, cateAppliedAmount) > totalAmount) {
          return `管理费科目累计请款金额超过${cateRoot == 2 ? '申请人' : '美丽心灵' }管理费`
        }
      }
      return ''
    },
    listBanks() {
      listApplyBillBanks().then(({ data }) => {
        if (data.success) {
          this.banks = data.result
        }
      })
    },
    onTitleChange(value) {
      let values = value ? value.split('♦') : []
      if (values.length == 3) {
        this.form.billTitle = values[0]
        this.form.bankName = values[1]
        this.form.bankCard = values[2]
      }
    },
    filterOption(input, option) {
      return option.data.key.toUpperCase().indexOf(input.toUpperCase()) >= 0
    },
    refreshAmount() {
      let records = this.budgetsTableData
      let applyTotal = 0
      records.forEach(record => {
        let apply = 0
        if (record.children) {
          record.children.forEach(item => {
            apply += parseFloat(item.applyAmount || 0)
          })
        }
        if (!record.sum) {
          record.applyAmount = apply
        }
        applyTotal += apply
      })
      let sumRecord = records.find(d => d.name == '合计')
      sumRecord.applyAmount = applyTotal
      this.$set(this.form, 'applyAmount', applyTotal)
      this.overLimited = applyTotal + sumRecord.applied > this.availableAmount
    },
    validItem(item) {
      let { uid, isRoot } = item
      if (!isRoot) {
        const overText = this.isOverApply(item)
        if (overText != '') {
          this.$message.warn(overText)
          this.$nextTick(() => {
            this.$refs[`applyAmount-${uid}`].focus()
          })
          return false
        }
      }
      return true
    },
    handleConfirm(nextStep) {
      this.$message.destroy()
      let { applyAmount, applyDate, billTitle, bankName, bankCard, applyRemark } = this.form
      if (!applyAmount) {
        this.$refs.applyAmount.focus()
        this.$message.warn('未设置请款金额')
        return
      }
      if (nextStep) {
        let budgets = this.budgetsTableData
        let validated = true
        for (let index = 0; index < budgets.length; index++) {
          let item = budgets[index]
          if (item.children) {
            for (let i = 0; i < item.children.length; i++) {
              if (!this.validItem(item.children[i])) {
                validated = false
                break
              }
            }
          }
          if (!validated) {
            break
          }
        }
        if (!validated) {
          return
        }
        if (!applyDate) {
          this.$message.warn('请选择申请日期')
          this.$refs.applyDate.focus()
          return
        }
        if (billTitle.trim() == '') {
          this.$message.warn('请输入收款单位抬头')
          this.$refs.billTitle.focus()
          return
        }
        if (bankName.trim() == '') {
          this.$message.warn('请输入开户行')
          this.$refs.bankName.focus()
          return
        }
        if (bankCard.trim() == '') {
          this.$message.warn('请输入银行账号')
          this.$refs.bankCard.focus()
          return
        }
        if (applyRemark.trim() == '') {
          this.$message.warn('请输入请款事项说明')
          this.$refs.applyRemark.focus()
          return
        }
      }
      this.$confirm({
        title: nextStep ? '确认提交请款单？' : '确认保存初稿？',
        centered: true,
        onOk: () => {
          this.handleSubmit(nextStep)
        },
      })
    },
    handleSubmit(nextStep) {
      this.saving = true
      let { isNum } = this.$utils
      let { projectId } = this
      let { applyId, applyAmount, applyDate, billTitle, bankName, bankCard, applyRemark } = this.form
      let applyBudgets = this.budgetsTableData
        .filter(d => d.children && d.children.length)
        .map(d => d.children)
        .flat()
        .filter(d => isNum(d.applyAmount))
        .map(d => ({ budgetId: d.budgetId, budgetPid: d.budgetPid, amount: d.applyAmount, projectId }))
      let params = {
        applyId,
        projectId,
        applyAmount,
        applyDate,
        billTitle: billTitle.trim(),
        bankName: bankName.trim(),
        bankCard: bankCard.trim(),
        applyRemark: applyRemark.trim(),
        origin: 1,
        nextStep,
        applyBudgets,
      }
      this.saving = true
      saveApplyBill(params)
        .then(({ data }) => {
          if (data.success) {
            if (nextStep) {
              this.applied = true
            } else {
              this.$message.success('操作成功')
              this.$router.push(`../view/finance?id=${projectId}`)
            }
          } else {
            this.$message.warning(data.msg)
          }
          this.saving = false
        })
        .catch(err => {
          if (err) {
            this.$message.warning(err)
          }
          this.saving = false
        })
    },
    getCheckboxProps(record) {
      return {
        props: {
          disabled: record.isRoot == 1,
        },
      }
    },
  },
  created() {
    this.init()
  },
}
</script>
